import { Box, Grid, styled, Typography } from "@mui/material";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { primary } from "../../constants/theme";
import { Context } from "../../context/context";
import { sendAnalytics } from "../../utils/analyticsCommon";
import { getCookie } from "../../utils/cookie";
import { useMobile } from "../../../src/utils/findViewport";
import MemoizedCustomerVehicleCard from "./VehicleCard2";
const CustomerVehiclesPage = styled(Box)(({ theme }) => ({
  width: "100vw",
  display: "flex",
  alignItems: "center",
  minHeight: "500px",
  flexDirection: "column",
  paddingLeft: "8%",
  paddingRight: "8%",
  ".content-container": {
    marginBottom: "40px",
    ".brand-name-heading": {
      fontSize: "24px",
      fontWeight: "600",
      lineHeight: "1.5",
      letterSpacing: "0em",
      marginBottom: "12px",
      paddingLeft: "2px",
      textAlign: "left",
    },
    ".subtext": {
      fontSize: "20px",
      marginBottom: "10px",
      fontWeight: "400",
      color: primary.black,
    },
  },
  ".vehicles-grid-container": {
    padding: "0",
    display: "flex",
    justifyContent: "flex-start",
  },
  ".expand-button" : {
    cursor: "pointer",
    width: "100px",
    height: "20px",
    textAlign: "initial",
    background:"none",
    fontSize: "14px",
    color: "black",
    fontWeight: "520",
    margin: "0px auto",
    border: "none",
    textDecoration: "underline",
  },
  [theme.breakpoints.down("md")]: {
    padding: "10px",
    ".content-container": {
      ".brand-name-heading": {
        fontSize: "24px",
      },
      ".subtext": {
        fontSize: "14px",
      },
    },
  },
  [theme.breakpoints.down("sm")]: {
    ".content-container": {
      paddingLeft: "12px",
      ".brand-name-heading": {
        fontSize: "24px",
      },
      ".subtext": {
        fontSize: "14px",
      },
    },
  },
}));
const BrandVehicleslisting = ({
  vehicleLocalData,
  headerInfo,
  description,
  ctaText,
  isHindi = false
}) => {
  const { showWhatsappPopup } = useContext(Context);
  const [isExpanded, setIsExpanded] = useState(false);
  const isMobile = useMobile();
  const showNumberOfCharacters = isMobile ? 175 : 280;

  const targetRef = useRef(null);
  const newVehiclesArray = [
    "Tuoro max++",
    "Rage + Frost",
    "Rage + 10.8 Kwh",
    "Rage + 8.5  Kwh",
    "HiLoadHD",
    "HiLoadDV",
    "Zor Grand",
    "E-Xtra FX Max",
  ]; //required for rendering the new vehicles pop up
  let cacheInfoSlider = getCookie("user_slided")
    ? JSON.parse(getCookie("user_slided"))
    : "";
  let cacheInfoUser = getCookie("user_verified")
    ? JSON.parse(getCookie("user_verified"))
    : "";
  // useEffect(() => {
  //   sendAnalytics("screen_viewed", { screen_name: "vehicle selection" }, "en");
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  useEffect(() => {
    if (
      localStorage?.getItem("phoneInfo") === null &&
      cacheInfoSlider?.slided === true &&
      cacheInfoUser?.verified !== true
    ) {
      showWhatsappPopup("Image_slided");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // this useeffect will work whenever there is any change in the searchvalue

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.8,
    };

    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        sendAnalytics("v2_scroll_vehicle_list", {}, "en");
      }
    }, options);

    if (targetRef.current) observer.observe(targetRef.current);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (targetRef.current) observer.unobserve(targetRef.current);
    };
  }, [targetRef]);

  const sortedVehicleLocalData = useMemo(() => {
    if (!Array.isArray(vehicleLocalData)) return [];

    const getPriority = (vehicle) => {
      const type = String(vehicle?.type || "").toLowerCase();

      // priority: passenger first, cargo4wheeler last, everything else treated as cargo
      if (type === "passenger" || type.includes("passenger")) return 0;
      if (type === "cargo4wheeler") return 2;
      return 1;
    };

    // keep original ordering within same priority
    return vehicleLocalData
      .map((v, idx) => ({ v, idx }))
      .sort((a, b) => getPriority(a.v) - getPriority(b.v) || a.idx - b.idx)
      .map(({ v }) => v);
  }, [vehicleLocalData]);

  const renderDescription = () => {
    if (isExpanded) {
      return description;
    }
    return description.length > showNumberOfCharacters
      ? `${description.substring(0, showNumberOfCharacters)}...`
      : description;
  };
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  const ButtonText = () => {
    if (isHindi) {
      if (isExpanded) {
        return "कम पढ़ें";
      } else {
        return "और पढ़ें";
      }
    } else {
      if (isExpanded) {
        return "Read Less";
      } else {
        return "Read More";
      }
    }
  };
  return (
    <CustomerVehiclesPage>
      <Grid
        container
        spacing={3}
        className="vehicles-grid-container"
        id="search-result"
      >
        <>
          <Grid item xs={12}>
            <Box
              className="content-container"
              id="brand-vehicle"
              ref={targetRef}
            >
             {headerInfo && <Typography variant="h1" className="brand-name-heading">
                {headerInfo}
              </Typography>}
              {description && description?.length > showNumberOfCharacters && (
                <Typography variant="p" className="subtext">
                  {renderDescription()}
                  <button onClick={toggleExpand} className="expand-button">
                    {ButtonText()}
                  </button>
                </Typography>
              )}
            </Box>
          </Grid>
          {sortedVehicleLocalData?.map((vehicle, index) => {
            return (
              <React.Fragment key={index}>
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <MemoizedCustomerVehicleCard
                    vehicleData={vehicle}
                    isNewVehicle={newVehiclesArray?.includes(
                      vehicle?.vehicle_name
                    )}
                    ctaText={ctaText}
                  />
                </Grid>
              </React.Fragment>
            );
          })}
        </>
      </Grid>
    </CustomerVehiclesPage>
  );
};
export const MemoizedBrandVehiclesListing = React.memo(BrandVehicleslisting);
